import React from 'react'
import { QuizProvider } from './contexts/QuizContext'

import Header from './components/Header'
import Content from './components/Content'
import Test from './components/Test'
import Footer from './components/Footer'

import './assets/sass/main.scss'

function App() {
  return (
    <div>
      <QuizProvider>
        <div className="wrapper">
          <Header />
          <Content />
          <Test />
        </div>
        <Footer />
      </QuizProvider>
    </div>
  )
}

export default App
